<template>
  <v-container>

    <stock-result
        v-if="done"
        :remove-transaction="removeTransaction"
        :add-transaction="addTransaction"
    />

    <v-row v-else>
      <v-col v-for="(item,index) in getItems" :key="index" cols="12" md="4">
        <product-stock
            :product="item.product"
            v-model="item.regularize"
            :in-stock="item.quantity"
            :minimum="item.minimum"
        >
        </product-stock>
      </v-col>
      <v-col cols="12" class="text-right">
        <submit-button :disabled="!isReady || submitting" @click="regularizeStock"></submit-button>

      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import ProductStock from "@/modules/delivery/components/ProductStock/ProductStock";
import {SubmitButton} from '@dracul/common-frontend'
import StockOperationProvider from "@/modules/delivery/providers/StockOperationProvider";
import StockResult from "@/modules/delivery/pages/stock/StockOperationPage/StockResult/StockResult";

export default {
  name: "StockRegularize",
  components: {StockResult, ProductStock, SubmitButton},
  props: {
    stock: Object,
  },
  data() {
    return {
      items: [],
      addTransaction: null,
      removeTransaction: null,
      submitting: false,
      clientMutationId: null,
      done: false
    }
  },
  computed:{
    getItems(){
      return this.stock.items.filter(i => i.hide === false)
    },
    getRegularizeItems(){
      return this.stock.items.filter(i => i.regularize > 0).map(i=> ({product: i.product.id, quantity:i.regularize}))
    },
    isReady() {
      return this.itemsToRegularize > 0
    },
    itemsToRegularize() {
      return this.stock.items.reduce((a, i) => (a + (i.regularize || 0)), 0)
    },
  },
  created() {
    this.clientMutationId = this.createClientMutationId()
  },
  methods: {
    regularizeStock() {
      if (this.submitting || this.itemsToRegularize === 0) {
        return
      }

      this.submitting = true
      StockOperationProvider.regularizeStockOperation(this.stock.id, this.getRegularizeItems, null, this.clientMutationId)
      .then((r)=> {
        console.log("stockRegularize",r)
        console.log(r.data.regularizeStockOperation)
        this.addTransaction = r.data.regularizeStockOperation.addTransaction
        this.removeTransaction = r.data.regularizeStockOperation.removeTransaction
        this.done = true
        this.$emit('stockRegularize',r)
      })
      .finally(() => {
        this.submitting = false
      })
    },
    createClientMutationId() {
      return [
        'regularize-stock',
        this.stock.id,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join('-')
    }
  }
}
</script>

<style scoped>

</style>
